export const removeScrollWrapperMask = () => {
	const scrollWrapper = document.querySelector('.scroll-wrapper')
	scrollWrapper.classList.remove('scroll-wrapper-mask')
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/scrollAnimation/helpers.js